import React from 'react';
import '../css/gtc-home.css';
import { useNavigate } from 'react-router-dom';
import { FaMapMarkerAlt, FaGlobeAmericas, FaUserCircle } from 'react-icons/fa';

const GTCHome: React.FC = () => {
    const navigate = useNavigate();

    const services = [
        {
            title: 'IP Geolocation',
            description: 'Instantly locate and track IP addresses with precision. Get comprehensive location data including country, city, coordinates, and more.',
            icon: <FaGlobeAmericas className="service-icon-svg" />,
            path: '/service/geo'
        },
        {
            title: 'Reverse Geocoding',
            description: 'Transform latitude and longitude coordinates into meaningful addresses. Get detailed location information from any geographical point.',
            icon: <FaMapMarkerAlt className="service-icon-svg" />,
            path: '/service/rgeo'
        }
    ];

    return (
        <div className="home-page">
            <div className="dashboard-header">
                <div className="welcome-section">
                    <div className="user-info">
                        {/* <FaUserCircle className="user-avatar" /> */}
                        <div className="welcome-text">
                            <h1>Welcome to Your Dashboard!</h1>
                            <p>Access your geolocation tools below</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="dashboard-content">
                <div className="quick-stats" style={{ display: 'none' }}>
                    <div className="stat-card">
                        <h3>API Calls Today</h3>
                        <p className="stat-number">150</p>
                    </div>
                    <div className="stat-card">
                        <h3>Remaining Credits</h3>
                        <p className="stat-number">850</p>
                    </div>
                </div>

                <div className="services-section">
                    <h2>Available Services</h2>
                    <div className="services-grid">
                        {services.map((service, index) => (
                            <div 
                                key={index} 
                                className="dashboard-card"
                                onClick={() => navigate(service.path)}
                            >
                                <div className="card-header">
                                    <div className="icon-wrapper">
                                        {service.icon}
                                    </div>
                                    <h3>{service.title}</h3>
                                </div>
                                <p className="card-description">{service.description}</p>
                                <button className="launch-button">
                                    <span>Launch</span>
                                    <svg className="button-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GTCHome; 